export { browserMeta } from './meta';



// WEBPACK FOOTER //
// ../../../../src/metas/browser/index.ts